import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/CustomerApiNew';
import ServiceSlidesPage from './ServiceSlidesPage'
import logo from '../logo/mb_logo_100x100.png'; // Import the image file
import './MainPage.css';
import './CreateTenderModal.css';
import CreateTenderModal from './CreateTenderModal';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';



const API_BASE_URL = '/api/v1';



// --- Utility Functions (Keep isAuthenticated for UI logic) ---

const isAuthenticated = () => {
	return localStorage.getItem('customerAccessToken') !== null;
};


// --- Components ---

// Header Component
const Header = () => {
	const navigate = useNavigate();

	const handleMyTendersClick = (e) => {
		e.preventDefault();
		if (isAuthenticated()) {
			navigate('/customer-dashboard');
		} else {
			navigate('/customer-login', { state: { from: '/customer-dashboard' } });
		}
	};

	return (
		<header className="header">
			{/* Grouping Logo and Brand Name */}
			<div className="logo-container" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
				<img src={logo} alt='Logo' className="logo-img" />
				<div className="logo-text">
					<span className="logo-orange">MYBHARAT</span><span className="logo-blue">SERVICE</span>
				</div>
			</div>
			<nav>
				<a href="/register">Professionals Registration</a>
				 |
				<a href="/login">Login</a>
				&nbsp; &nbsp; &nbsp; &nbsp;
				<a href="/customer-login">Customer Login</a>
				&nbsp; | &nbsp;
				<a href="/customer-dashboard" onClick={handleMyTendersClick}>My Bookings</a>
				&nbsp; | &nbsp;
				<a href="/admin-login">Admin Login</a>
			</nav>
		</header>
	);
};

// Callback Request Modal Component (Simplified)
const CallbackModal = ({ providerId, onClose, onCallbackSuccess, setRevealedContacts, setLoadingIds }) => {
	const [step, setStep] = useState(1); // 1: Ask details, 2: Verify OTP
	const [phone, setPhone] = useState('');
	const [otp, setOtp] = useState('');
	const [allAccepted, setAllAccepted] = useState(true);
	const [message, setMessage] = useState('');
	const [customer, setCustomer] = useState({});
	const [name, setName] = useState('')
	const [sendingOTP, setSendingOTP] = useState(false);
	const [verifyingOTP, setVerifyingOTP] = useState(false);


	const handleSendOtp = async () => {
		const fullPhone = `+91${phone}`;
		setSendingOTP(true);
		try {
			// Use 'api.post' instead of 'axios.post'
			const res = await api.post(`${API_BASE_URL}/auth/otp/sendV2`, {
				phone: fullPhone,
				purpose: 'CALLBACK'
			});
			setCustomer({ ...(res?.data || {}), phone: fullPhone });
			setStep(2);
			setMessage('OTP sent successfully!');
		} catch (error) {
			setMessage('Failed. Too Many OTP sent, Try later!');
		} finally {
			setSendingOTP(false);
		}

	};


	const handleVerifyOtpAndSubmitCallback = async () => {
		try {
			// Step 1: Verify OTP and Authenticate
			// Use 'api.post'
			setVerifyingOTP(true);
			const verifyResponse = await api.post(`${API_BASE_URL}/auth/otp/verify`, {
				phone: customer.phone,
				otp,
				purpose: 'CALLBACK',
				name: name || customer.name, // Use local state name or object name
				consentType: allAccepted ? ["Allow to share your data with service providers.", "Allow notification for offers and marketing"] : [],
				allAccepted,
			});

			localStorage.setItem('customerAccessToken', verifyResponse.data.accessToken);
			localStorage.setItem('customerRefreshToken', verifyResponse.data.refreshToken); // Ensure you store refresh token too

			//setCustomer(prev => ({ ...prev, name : name || customer.name }));
			localStorage.setItem('customer', JSON.stringify(customer));


			// Step 2: Submit Callback Request
			// This call now uses the 'api' instance which automatically adds the *newly stored* accessToken via the interceptor.
			/*if (showViewContact) {
				await submitViewContact(providerId, customer);
				setMessage('Contacts unlocked successfully!');

				onViewContactSuccess();

			} else {*/

			await submitCallback(providerId, customer);
			setMessage('Authenticated successfully!');
			// Notify the parent component that this specific provider request succeeded
			onCallbackSuccess(providerId);

			onClose();
		} catch (error) {
			setMessage('OTP verification failed');
		} finally {
			setVerifyingOTP(false)
		}
	};

	const submitCallback = async (pId, customerData) => {
		const params = JSON.parse(localStorage.getItem('searchParam'));
		setLoadingIds(prev => ({ ...prev, [pId]: true }));

		// Use 'api.post'. Interceptor handles headers now.
		const response = await api.post(`${API_BASE_URL}/callback-request/send`, {
			providerId: pId, customerName: customerData.name, customerPhone: customerData.phone,
			customerCity: params.city, customerState: params.state, serviceType: params.serviceType
		});

		const contactNumber = response.data;

		setRevealedContacts(prevs => ({ ...prevs, [pId]: contactNumber }));
		setLoadingIds(prev => ({ ...prev, [pId]: false }));

	};

	/*const submitViewContact = async (pId, customerData) => {
		const params = JSON.parse(localStorage.getItem('searchParam'));
		// Use 'api.post'. Interceptor handles headers now.
		await api.post(`${API_BASE_URL}/lead/send`, {
			providerId: pId, name: customerData.name, phone: customerData.phone,
			city: params.city, state: params.state, serviceType: params.serviceType
		});
	};
*/
	const handleCallbackInitiation = async () => {
		if (isAuthenticated()) {
			try {
				// Interceptor handles the token automatically



				const customerData = JSON.parse(localStorage.getItem('customer') || '{}');

				/*if (showViewContact) {
					await submitViewContact(providerId, customerData);
					setMessage('Contacts unlocked successfully!');
					onViewContactSuccess();

				} else {*/

				await submitCallback(providerId, customerData);
				setMessage('Callback requested successfully!');
				// Notify success even if already authenticated
				onCallbackSuccess(providerId)



				onClose();
			} catch (error) {
				// Interceptor handles 401 errors (e.g. token expired) by refreshing/logging out
				setMessage('Failed to submit callback request or authentication expired.');
			}
		}
		// If not authenticated, the UI naturally proceeds to step 1
	};

	useEffect(() => {
		if (isAuthenticated()) {
			handleCallbackInitiation();
		}
	}, []);


	if (isAuthenticated() && step === 1) { // Added step check
		return <div>Submitting request...</div>
	}

	const handleNameChange = (e) => {
		const value = e.target.value;
		setName(value);
	}

	const handleBlur = (e) => {
		const { name, value } = e.target;
		setCustomer(prev => ({ ...prev, [name]: value }))
	}



	return (
		<div className="modal-overlay">
			{/* ... Modal content JSX as before ... */}
			<div className="modal-content">
				<h3>Request Callback</h3>
				<p>{message}</p>
				{step === 1 && (
					<>
						<div className='phone-input-group'>
							<span>+91</span>
							<input type="tel" placeholder="Phone Number" onChange={(e) => setPhone(e.target.value)} maxLength={10} />
						</div>
						{/* Modified structure here: */}

						<button onClick={handleSendOtp} disabled={!phone || sendingOTP}>
							{sendingOTP ? "Sending OTP..." : "Send OTP"}</button> &nbsp;&nbsp;&nbsp;&nbsp;
					</>
				)}
				{step === 2 && (
					<>

						<input type="text" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} minLength={6} maxLength={6} />

						{!customer.name && <>
							<input type="text" name="name" value={name} placeholder="Your Name"
								onChange={handleNameChange} onBlur={handleBlur} />
						</>

						}


						<div className="checkbox-group">
							<label>
								<input type="checkbox" checked={allAccepted} onChange={(e) => setAllAccepted(e.target.checked)} />
								Allow sharing data and notifications (Required)
							</label>
						</div>
						<button onClick={handleVerifyOtpAndSubmitCallback} disabled={!otp || (!name && !customer.name) || !allAccepted || verifyingOTP}>
							{verifyingOTP ? "Verifying..." : "Submit"} </button>
					</>
				)}
				<button onClick={onClose}>Close</button>
			</div>
		</div>
	);
};


// Provider Card Component (No changes needed here)

/*const ProviderCard = ({ provider, onCallbackRequest, isRequested, isAuthenticated, showViewContact }) => {*/
const ProviderCard = ({ provider, onCallbackRequest, revealedContactsMap, loadingIdsList }) => {
	const navigate = useNavigate();

	const handleCardClick = () => {
		navigate(`/provider/${provider.providerId}`);
	};

	return (
		<div className="provider-card" onClick={handleCardClick}>
			<div className="card-header">
				<h4 className="provider-name">{provider.name}</h4>
				<span className="provider-city">
				  {provider.area ? `${provider.area}, ${provider.city}` : provider.city}
				</span>

			</div>

			<div className="service-area">
				<span className="label">Service Area:</span>
				<span className="value">{Array.isArray(provider.serviceCities) ? provider.serviceCities.join(' | ') : provider.serviceCities}</span>
			</div>

			<div className="stats-row">
				<span><strong>Exp:</strong> {provider.experience} years</span>
				<span className="divider">|</span>
				{ provider.charge && <span><strong>Charge:</strong> ₹{provider.charge} {provider.chargeType}</span>}
				{ provider.vegCharge && <span><strong>Veg: </strong> ₹{provider.vegCharge}</span>}
				{ provider.nonVegCharge && <span><strong>Non Veg Per Plate:</strong> ₹{provider.nonVegCharge}</span>}
				{ provider.banquetCharge && <span><strong>Banquet Charge:</strong> ₹{provider.banquetCharge}</span>}


			</div>

			{/*<div className="contact-info">
				<p>📞 {revealedContactsMap.inc provider.contact.phone}</p>
				<p>✉️ {provider.contact.email}</p>
			</div>*/}

			<p className="services-desc">{provider.services}</p>


			<div className="action-buttons-row">
				{revealedContactsMap[provider.providerId] ? (
					<a
						href={`tel:${revealedContactsMap[provider.providerId]}`}
						className="btn-jd-phone"
						onClick={(e) => e.stopPropagation()}
					>
						<span className="phone-icon">📞</span>
						<span className="phone-text-num">{revealedContactsMap[provider.providerId]}</span>
					</a>
				) : (
					<button
						className="btn-jd-phone"
						onClick={(e) => { e.stopPropagation(); onCallbackRequest(provider.providerId); }}
						disabled={!!loadingIdsList[provider.providerId]}
					>
						<span className="phone-icon">📞</span>
						<span className="phone-text-num">
							{loadingIdsList[provider.providerId] ? "Fetching..." : "Show Number"}
						</span>
					</button>
				)}

				{provider.rating > 0 && (
					<span className="provider-card-rating" title="Customer rating">
						<span className="provider-card-rating-star">★</span>
						{provider.rating.toFixed(1)}
					</span>
				)}
			</div>



		</div>
	);
};


const TENDER_STEPS = [
	{
		number: '01',
		title: 'Create a Hire Request',
		text: 'Post your requirement with service type, specialization, city, locality, work description, timeline and up to 5 reference photos.',
		tag: 'Up to 5 Photos · Free to Post'
	},
	{
		number: '02',
		title: 'We Match Verified Professionals',
		text: 'Your request reaches verified professionals who actually serve your service category and your city — so you never wait for bids that never come.',
		tag: 'Verified Profiles · City Matched'
	},
	{
		number: '03',
		title: 'Professionals Submit Rate Through Bids',
		text: 'Interested professionals get an instant WhatsApp alert and submit bid with their charge, charge type, and approach — so every bid is comparable.',
		tag: 'WhatsApp Alerts · Comparable Bids'
	},
	{
		number: '04',
		title: 'Compare & Assign',
		text: 'Compare bids, ratings and past reviews of professionals, then assign the work to the professional you trust and get their contact instantly.',
		tag: 'Ratings & Reviews · Direct Contact'
	}
];

const TENDER_HIGHLIGHTS = [
	'One hire request, multiple competing bids',
	'Only verified professionals from your city',
	'Add photos so bids match your actual work'
];

// Tender Process Section
const TenderProcessSection = ({ onCreateTender }) => (
	<section className="tender-process-section">
		<div className="tender-process-intro">
			<h2>Post a Hire request in Minutes. Get Competing Bids from Verified Professionals.</h2>
			<p>
				Describe your work once — service type, city, timeline, budget expectations and reference photos.
				We share it with verified professionals serving your category in your city.
			</p>
			<p>
				No more calling 10 professionals one by one. No more quotes you cannot compare.
				Just one hire request, multiple structured Bids, and your choice.
			</p>

			<ul className="tender-process-highlights">
				{TENDER_HIGHLIGHTS.map(item => (
					<li key={item}><span className="tender-check">&#10003;</span>{item}</li>
				))}
			</ul>

			<button type="button" className="tender-process-cta" onClick={onCreateTender}>
				<span className="plus-icon">+</span> Create Your Hire Request
			</button>
		</div>

		<ol className="tender-process-steps">
			{TENDER_STEPS.map((step, index) => (
				<li key={step.number} className={`tender-step ${index === 0 ? 'tender-step-active' : ''}`}>
					<span className="tender-step-number">{step.number}</span>
					<div className="tender-step-body">
						<h3>{step.title}</h3>
						<p>{step.text}</p>
						<span className="tender-step-tag">{step.tag}</span>
					</div>
				</li>
			))}
		</ol>
	</section>
);


// Main Page Component
const MainPage = () => {
	const [requestedProviderIds, setRequestedProviderIds] = useState(new Set());
	const [services, setServices] = useState(null);

	const [revealedContacts, setRevealedContacts] = useState({});
	const [loadingIds, setLoadingIds] = useState({});
	const [pageNumber, setPageNumber] = useState(0);
	const [hasMore, setHasMore] = useState(true);

	const [selectedServiceType, setSelectedServiceType] = useState('');
	const [selectedServiceSubType, setSelectedServiceSubType] = useState();
	const [city, setCity] = useState();
	const [stateVal, setStateVal] = useState('');
	const [providers, setProviders] = useState([]);

	const [nextCursor, setNextCursor] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState('');
	const [activeProviderIdForCallback, setActiveProviderIdForCallback] = useState(null);
	const [showCreateTenderModal, setShowCreateTenderModal] = useState(false);

	// This flag tracks if the user has unlocked the current search results
	const [isSearchUnlocked, setIsSearchUnlocked] = useState(false);

	const { serviceType, city: cityParam } = useParams();
	const navigate = useNavigate();

	const resultsRef = useRef(null); // Create the layout reference anchor


	// Callback handler passed to the Modal
	const handleCallbackSuccess = useCallback((providerId) => {
		setRequestedProviderIds(prevIds => new Set(prevIds).add(providerId));

	}, []);

	/*const handleViewContactSuccess = () => {
		// This is the "Second Time Call" logic
		setIsSearchUnlocked(true);
		fetchProviders(true);
	}*/

	const handleCreateTenderClick = () => {
		if (!isAuthenticated()) {
			navigate('/customer-login');
			return;
		}
		setShowCreateTenderModal(true);
	};

	const popularCities = [
		"Bangalore", "Mumbai", "Chennai", "Delhi", "Hyderabad", "Pune", "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro",
		"Ahmedabad", "Lucknow", "Patna", "Jaipur", "Indore", "Kochi",
		"Kolkata", "Coimbatore", "Nagpur", "Ludhiana", "Agra", "Bhubaneshwar",
		"Bhopal", "Guwahati", "Surat", "Madurai", "Visakhapatnam", "Sonepat",
		"Vadodara", "Meerut"
	];

	const BUILDING_SERVICES = ["Civil Engineer", "Building Contractor", "Civil Contractor", "Tiling Contractor", "Electrician",
		 "Plumber", "Painter", "Carpenter", "Glass Installer", "Window Installer", "Railing Installer"];


	const toPascalCase = (str) => {
		if (!str) return '';
		return str
			.split(/[\s_-]+/) // Handles spaces, hyphens, and underscores
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const getServiceContext = (service) => {
		const normalized = service?.toLowerCase() || '';

		// 1. Professional & Business Services
		const corporate = ['lawyer', 'ca', 'civil engineer', 'website designer', 'property consultant', 'interior designer'];
		// 2. Events, Weddings & Creative Services
		const creative = ['event planner', 'photographer', 'makeup artist', 'mehandi artist', 'wedding choreographer'];
		// 3. Healthcare, Wellness & Education
		const care = ['psychologist', 'nurse', 'physiotherapist', 'care taker', 'home care', 'dietitian', 'home tutor'];
		// 4. Local Tradition & Home Utilities
		const homeAndTradition = ['electrician', 'plumber', 'pujari'];

		if (corporate.includes(normalized)) {
			return {
				category: 'corporate',
				tagline: 'consult top-rated certified consultants & professional agencies',
				cta: 'Book Professional Consultation',
				faqAns1: 'Check their professional registration, portfolio of past work, client testimonials, and industry experience listed on their verified MyBharatService profile.'
			};
		}
		if (creative.includes(normalized)) {
			return {
				category: 'creative',
				tagline: 'hire top-rated creative artists and booking agencies for your special events',
				cta: 'Check Availability & Portfolios',
				faqAns1: 'Review their media portfolios, packages, booking calendars, and previous customer event ratings on MyBharatService to match your style.'
			};
		}
		if (care.includes(normalized)) {
			return {
				category: 'care',
				tagline: 'find trusted wellness experts, verified medical assistance, and personal tutors',
				cta: 'Hire Certified Care Experts',
				faqAns1: 'Verify their backgrounds, academic certifications, past medical or teaching experiences, and consumer trust badges before booking.'
			};
		}
		// Default to Home and Tradition (Plumber, Electrician, Pujari)
		return {
			category: 'local',
			tagline: 'book expert on-demand technicians and traditional services right to your doorstep',
			cta: 'Book Doorstep Service Now',
			faqAns1: 'Look for proximity, immediate availability, verified background checks, and clear service rate charts on our local directory platform.'
		};
	};




	// 1. Fetch initial service data
	useEffect(() => {
		const fetchLoaderData = async () => {
			try {
				// Use 'api.get'
				const response = await api.get(`${API_BASE_URL}/loader/load`);
				setServices(response.data);
				setIsLoading(false);
			} catch (err) {
				setError('Failed to load initial data');
				setIsLoading(false);
			}
		};
		fetchLoaderData();
	}, []);

	// Read url and populate search field for SEO

	useEffect(() => {

		if (!serviceType || !services) {
			return;
		}

		// Convert 'home-care' back to 'home care' for an accurate string match
		const normalizedServiceParam = serviceType.toLowerCase().replace(/-/g, ' ');

		const matchedService = services.serviceType.find(
			s => s.toLowerCase() === normalizedServiceParam
		);

		if (!matchedService) return;

		setSelectedServiceType(matchedService);

		if (!cityParam) {
			return;
		}
		setCity(cityParam);

		fetchProviders(
			0,
			matchedService,
			cityParam
		);

	}, [serviceType, cityParam, services]);




	// 1. Fetch Providers Function
	const fetchProviders = async (pageNumber = 0, serviceTypeArg, cityArg) => {

		setIsLoading(true);
		setError(null); // Clear previous errors on retry

		try {
			const params = {
				serviceType: serviceTypeArg || selectedServiceType,
				serviceSubType: selectedServiceSubType || undefined,
				city: cityArg || city,
				pageNumber
			};

			// Use 'api.get'
			const response = await api.get(`${API_BASE_URL}/providers/search`, { params });

			const newProviders = response.data;


			// If backend returns less than requested size, database stream is exhausted
			if (!newProviders || newProviders.length < 20) {
				setHasMore(false);
			} else {
				setHasMore(true);
			}

			// Action routing based on pagination layer position
			if (pageNumber === 0) {
				setProviders(newProviders); // Replace layout entirely for fresh searches
			} else {
				setProviders(prev => [...prev, ...newProviders]); // Merge rows on Load More requests
			}



			if (pageNumber === 0 && (!newProviders || newProviders.length === 0)) {
				setError(`MyBharatService is expanding its ${serviceType} network in ${cityParam}.
				If you are a  ${serviceType} in ${cityParam}, register today and start receiving customer enquiries directly on WhatsApp.`);
			}

			setIsLoading(false);


		} catch (err) {
			setError('Search failed.');
			setIsLoading(false);
		} finally {
			setIsLoading(false);

		}

	};

	const handleSearch = async () => {
		// ... (validation logic is the same)
		if (!selectedServiceType || !city) {
			setError('Please Select Service Type, and Enter City Name');
			return;
		}
		setPageNumber(0);
		setHasMore(true);
		setIsLoading(true);
		setError('');


		const searchParam = {
			serviceType: selectedServiceType,
			serviceSubType: (services.showServiceSubTypeFor.includes(selectedServiceType)) ? selectedServiceSubType : undefined,
			city,
			state: stateVal,
		};

		localStorage.setItem('searchParam', JSON.stringify(searchParam));

		navigate(
			`/service/${selectedServiceType.toLowerCase().replace(/\s+/g, '-')}/${city.toLowerCase().replace(/\s+/g, '-')}`
		);

		fetchProviders(0); // only passing pageNumber value, fields are always optional to pass, remaining filed will be used from Global state

	};

	// New dedicated effect hook to manage scrolling when provider data arrives
	useEffect(() => {
		if (providers.length > 0 && resultsRef.current) {
			resultsRef.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [providers.length]); // Listens exactly when the array length updates from your fetch

	const handleCallbackRequest = (providerId) => {
		setActiveProviderIdForCallback(providerId);
	};


	useEffect(() => {
		// If both parameters are missing, the user is back at the root home view.
		// We instantly flush out old states so it falls back to the clean categories grid.
		if (!serviceType && !cityParam) {
			setProviders([]);             // Wipes out old results cards array
			setNextCursor(null);          // Resets pagination tracker
			setError('');                 // Clears previous search error warnings
			setSelectedServiceType(null); // Resets active category selector
			setCity('');                  // Wipes input field component text string
		}
	}, [serviceType, cityParam]); // Fires automatically when URL changes back to '/' via logo click



	if (isLoading && !services && !providers.length) return <div>Loading ServiceDekho...</div>;

	// Function to block everything except letters, numbers, and spaces
	const blockSpecial = (val) => val.replace(/[^a-zA-Z0-9 ]/g, "");


	const pService = serviceType ? toPascalCase(serviceType) : 'professional';
	const pCity = cityParam ? toPascalCase(cityParam) : 'near me';

	const ctx = getServiceContext(serviceType);

	const dynamicTitle = serviceType && cityParam
		? `Best ${pService}s in ${pCity} | Top Verified ${pService} Near Me - MyBharatService`
		: 'Find Trusted Local Professionals & Services Near You - MyBharatService';

	const dynamicDesc = serviceType && cityParam
		? `Looking for the best ${pService}s in ${pCity}? Compare profiles, check verified reviews, find accurate contact numbers, and ${ctx.tagline} via MyBharatService.`
		: 'Find and book 20+ verified local service professionals across India including Lawyers, CAs, Engineers, Home Tutors, Pujaris, and Electricians.';

	const dynamicKeywords = serviceType && cityParam
		? `best ${pService} in ${pCity}, top ${pService}s ${pCity}, verified ${pService} near me, local ${pService} service booking, register as ${pService} ${pCity}, MyBharatService`
		: 'local business directory, find professional services, home repair, wedding vendors, home care nursing, local tutor search';

	const canonicalUrl = serviceType && cityParam
		? `https://mybharatservice.com{serviceType.toLowerCase()}/${cityParam.toLowerCase()}`
		: 'https://mybharatservice.com';


	// Setup your FAQ Schema object for search engines
	const faqSchema = {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		"mainEntity": [
			{
				"@type": "Question",
				"name": `How can I find and hire the best ${pService} in ${pCity}?`,
				"acceptedAnswer": {
					"@type": "Answer",
					"text": ctx.faqAns1
				}
			},
			{
				"@type": "Question",
				"name": `Are the profiles of ${pService}s listed in ${pCity} verified?`,
				"acceptedAnswer": {
					"@type": "Answer",
					"text": `Yes. Every listed ${pService} on MyBharatService undergoes a comprehensive screening process.`
				}
			}
		]
	};


	return (
		<>
			{/* ======================================================== */}
			{/* STEP 1: METADATA & SCHEMA (Invisible to users, read by bots) */}
			{/* ======================================================== */}

			<Helmet>
				<title>{dynamicTitle}</title>
				<meta name="Title" content={dynamicTitle} />
				<meta property="og:title" content={dynamicTitle} />
				<meta name="twitter:title" content={dynamicTitle} />

				<meta name="description" content={dynamicDesc} />
				<meta property="og:description" content={dynamicDesc} />
				<meta name="twitter:description" content={dynamicDesc} />

				<meta name="keywords" content={dynamicKeywords} />
				<link rel="canonical" href={canonicalUrl} />
				<meta name="robots" content="index, follow" />

				{/* 1. Breadcrumb List (Safe to render instantly via URL params) */}
				<script type="application/ld+json">
					{JSON.stringify({
						"@context": "https://schema.org",
						"@type": "BreadcrumbList",
						"itemListElement": [
							{
								"@type": "ListItem",
								"position": 1,
								"name": "Home",
								"item": "https://mybharatservice.com"
							},
							{
								"@type": "ListItem",
								"position": 2,
								"name": "Services",
								"item": "https://mybharatservice.com/service"
							},
							{
								"@type": "ListItem",
								"position": 3,
								"name": `${toPascalCase(serviceType || 'Service')}s`,
								"item": `https://mybharatservice.com/service/${(serviceType || '').toLowerCase()}`
							},
							{
								"@type": "ListItem",
								"position": 4,
								"name": `${toPascalCase(cityParam || 'Local')}`,
								"item": `https://mybharatservice.com/service/${(serviceType || '').toLowerCase()}/${(cityParam || '').toLowerCase()}`
							}
						]
					})}
				</script>


				{/* 2. Guarded ItemList (Only evaluates and renders when API results actually arrive) */}
				{Array.isArray(providers) && providers.length > 0 && (
					<script type="application/ld+json">
						{JSON.stringify({
							"@context": "https://schema.org",
							"@type": "ItemList",
							"name": `${toPascalCase(serviceType)}s in ${toPascalCase(cityParam)}`,
							"description": `List of top verified local ${serviceType}s serving ${cityParam}`,
							"itemListElement": providers.slice(0, 5).map((provider, index) => ({
								"@type": "ListItem",
								"position": index + 1,
								"item": {
									"@type": "LocalBusiness",
									"name": provider.name || `${toPascalCase(serviceType)} Professional`,
									"address": {
										"@type": "PostalAddress",
										"addressLocality": cityParam,
										"addressCountry": "IN"
									}
								}
							}))
						})}
					</script>
				)}

			</Helmet>

			{/* Injecting the structured JSON-LD Schema markup data */}
			<script type="application/ld+json">
				{JSON.stringify(faqSchema)}
			</script>

			<div className="main-container">

				<Header />
				<div className="hero-section">
					<button type="button" className="hero-create-tender-btn" onClick={handleCreateTenderClick}>
						<span className="plus-icon">+</span> Create Hire Request
					</button>

					{serviceType && cityParam ? (
						<h1>
							Top {pService}s in {pCity} | Verified Local Experts
						</h1>
					) : (
						<h1>
							Find the best professionals in your city
						</h1>
					)}
					<div className="search-widget">
						<select value={selectedServiceType} onChange={(e) => {
							setSelectedServiceType(e.target.value);
							setSelectedServiceSubType('');
						}}>
							<option value="">Select Service Type</option>
							{services?.serviceType.map(service => (
								<option key={service} value={service}>{service}</option>
							))}
						</select>
						{(services?.showServiceSubTypeFor?.includes(selectedServiceType)) && (
							<select value={selectedServiceSubType} onChange={(e) => setSelectedServiceSubType(e.target.value)}>
								<option value="">Select Specialization(optional)</option>
								{selectedServiceType === 'Lawyer' ? services?.subTypeForLawyer?.map(subType => (
									<option key={subType} value={subType}>{subType}</option>
								))
									: selectedServiceType === 'Event Planner' ? services?.subTypeForEvent?.map(subType => (
										<option key={subType} value={subType}>{subType}</option>
									)) : BUILDING_SERVICES.includes(selectedServiceType) ? services?.subTypeForBuildingContractor?.map(subType => (
										<option key={subType} value={subType}>{subType}</option>
									)) : selectedServiceType === 'Civil Contractor' ? services?.subTypeForCivilContractor?.map(subType => (
										<option key={subType} value={subType}>{subType}</option>
									))
										: services?.serviceSubType?.map(subType => (
											<option key={subType} value={subType}>{subType}</option>
										))}
							</select>
						)}


						<input
							type="text"
							placeholder="City"
							value={city}
							onChange={(e) => setCity(blockSpecial(e.target.value))}
							onBlur={(e) => setCity(e.target.value.trim())}
						/>

						{/*<input
						type="text"
						placeholder="State"
						value={stateVal}
						onChange={(e) => setStateVal(blockSpecial(e.target.value))}
						onBlur={(e) => setStateVal(e.target.value.trim())}
					/>*/}

						<button
							disabled={isLoading || !selectedServiceType || !city?.trim()}
							onClick={() => handleSearch()}>
							{isLoading ? "Searching..." : "Search Providers"}
						</button>

						{/*<button onClick={() => handleSearch(null)}>Search Providers</button>*/}

						{/*<button disabled = {!selectedServiceType || !city}
							onClick={() => {

								navigate(
									`/service/${selectedServiceType.toLowerCase()}/${city.toLowerCase()}`
								);
							}}>
							Search Providers
						</button>*/}


					</div>
					{error && <p className="error-message">{error}</p>}
				</div>

				<main>
					{providers.length === 0 && <ServiceSlidesPage />}
					{providers.length > 0 && (
						<div ref={resultsRef} className="search-results-section" style={{ scrollMarginTop: '24px' }}>
							<h1>Available {toPascalCase(serviceType)}s in {city}</h1>
							<p style={{ fontSize: '1.2rem', color: '#555' }}>
								{pService} Services in {pCity}: {ctx.tagline}.
							</p>
							<div className="provider-list">

								{/*{providers.map(provider => (
									<ProviderCard
										key={provider.providerId}
										provider={provider}
										onCallbackRequest={handleCallbackRequest}
										isRequested={requestedProviderIds.has(provider.providerId)}
										isAuthenticated={isAuthenticated()}
										showViewContact={!isSearchUnlocked}
									/>
								))}*/}

								{providers.map(provider => (
									<ProviderCard
										key={provider.providerId}
										provider={provider}
										onCallbackRequest={handleCallbackRequest}
										revealedContactsMap={revealedContacts}
										loadingIdsList={loadingIds}
										showViewContact={!isSearchUnlocked}
									/>
								))}
							</div>
							{isLoading && <p style={{ textAlign: 'center', marginTop: '15px' }}>Loading data...</p>}


							{!isLoading && hasMore && <button onClick={() => {
								const nextPage = pageNumber + 1;
								setPageNumber(nextPage);
								fetchProviders(nextPage)
							}}>Load More</button>}
						</div>
					)}
				</main>

				{/*{activeProviderIdForCallback && (
					<CallbackModal
						providerId={activeProviderIdForCallback}
						onClose={() => setActiveProviderIdForCallback(null)}
						onCallbackSuccess={handleCallbackSuccess}
						showViewContact={!isSearchUnlocked}
						onViewContactSuccess={handleViewContactSuccess}

					/>
				)}*/}


				{activeProviderIdForCallback && (
					<CallbackModal
						providerId={activeProviderIdForCallback}
						onClose={() => setActiveProviderIdForCallback(null)}
						onCallbackSuccess={handleCallbackSuccess}
						setRevealedContacts={setRevealedContacts}
						setLoadingIds={setLoadingIds}
					/>
				)}

				{showCreateTenderModal && (
					<CreateTenderModal
						loaderData={services}
						onClose={() => setShowCreateTenderModal(false)}
					/>
				)}

				<TenderProcessSection onCreateTender={handleCreateTenderClick} />

				{/* ======================================================== */}
				{/* STEP 4: DYNAMIC FAQ ACCORDION (Visible at the bottom)    */}
				{/* ======================================================== */}
				<section className="seo-faq-accordion-section" style={{ marginTop: '40px', padding: '20px' }}>
					<h2>Frequently Asked Questions About {pService}s in {pCity}</h2>

					<div className="faq-node" style={{ marginBottom: '15px' }}>
						<h3><strong>Q1: How can I find and hire the best {pService} in {pCity}?</strong></h3>
						<p><strong>A:</strong> {ctx.faqAns1}</p>
					</div>

					<div className="faq-node" style={{ marginBottom: '15px' }}>
						<h3><strong>Q2: Are the profiles of {pService}s listed in {pCity} verified?</strong></h3>
						<p><strong>A:</strong> Yes. Every listed {pService} on MyBharatService undergoes a comprehensive screening process to ensure baseline professional credentials, phone updates, and genuine client interactions.</p>
					</div>

					<div className="faq-node" style={{ marginBottom: '15px' }}>
						<h3><strong>Q3: How much do {pService} services typically cost in {pCity}?</strong></h3>
						<p><strong>A:</strong> Pricing maps directly to project scale, professional background, or service depth. Review their itemized rate cards or use direct contact options on MyBharatService for immediate price quotes.</p>
					</div>
				</section>

				<h3 style={{ fontSize: '1.2rem', color: '#333', marginBottom: '20px' }}>
					Popular Cities for {toPascalCase(serviceType)} Services
				</h3>

				<div className="cities-link-grid" style={{
					display: 'grid',
					gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
					gap: '15px',
					maxWidth: '900px',
					margin: '0 auto'
				}}>


					{serviceType && popularCities.map(cityName => (
						<Link
							key={cityName}
							to={`/service/${serviceType.toLowerCase()}/${cityName.toLowerCase()}`}
							style={{
								textDecoration: 'none',
								color: '#007bff',
								fontSize: '0.95rem',
								padding: '8px',
								border: '1px solid #eef2f5',
								borderRadius: '4px',
								backgroundColor: '#fdfdfd'
							}}
							className="city-link-item"
						>
							{toPascalCase(serviceType)} in {cityName}
						</Link>
					))}
				</div>


				<footer className="sd-footer">
					<div className="footer-container">
						{/* Brand Section */}
						<div className="footer-brand">
							<div className="logo-text">
								<span className="logo-orange">MYBHARAT</span><span className="logo-blue">SERVICE</span>
							</div>
							<p>Your trusted marketplace for local services like Nursing, Wedding Planner, Lawyer, CA, Home Care, and more.</p>
						</div>



						{/* Quick Links Section */}
						<div className="footer-links">
							<h4>Quick Links</h4>
							<ul>
								<li><Link to="/about-us">About Us</Link></li>
								<li><Link to="/contact-us">Contact Us</Link></li>
								<li><Link to="/terms-conditions">Terms & Conditions</Link></li>
								<li><Link to="/privacy-policy">Privacy Policy</Link></li>
								<li><Link to="/refund-policy">Refund Policy</Link></li>
							</ul>
							<div className="footer-contact-box">
								<p>Need Help?</p>
								<a href="tel:+917899295998" className="footer-tel">
									+91 7899295998
								</a>
							</div>

						</div>

						{/* Social Media Section */}
						<div className="footer-social">
							<h4>Follow Us</h4>
							<div className="social-btns">
								<a href="https://facebook.com" target="_blank" rel="noreferrer" className="fb-btn">Facebook</a>
								<a href="https://instagram.com" target="_blank" rel="noreferrer" className="insta-btn">Instagram</a>
							</div>
							<p className="copyright-text">MyBharatService is a registered brand owned and operated by CITIKART ONLINE SERVICE PRIVATE LIMITED. © 2026 All Rights Reserved.
							</p>
						</div>
					</div>
				</footer>

				{/* 2. Floating WhatsApp Button */}
				<a href="https://wa.me/917899295998"
					target="_blank"
					rel="noreferrer"
					className="whatsapp-float">
					<img
						src="/whatsapp-icon.svg"
						alt="WhatsApp Chat"
						className="wa-icon"
					/>
					<span className="wa-text">Chat with us</span>
				</a>

			</div>
		</>
	);
};

export default MainPage;
